import Vue from 'vue'
import Vant from 'vant/es'
import 'vant/lib/index.css'
 
Vue.use(Vant)